import { deferShellRender } from '../ui/shell_input_guard.mjs';
import { AppRuntime } from '../app/app_runtime.js?v=20260706d';
import * as FloorplanController from '../viewport/floorplan_controller.js?v=20260903c';
import {
  canRedo,
  canUndo
} from '../services/history_service.js?v=20260903c';
import { escapeHtml } from '../utils/html_utils.js?v=20260706d';
import { S } from '../app/app_state.js?v=20260817c';
import { syncGlobalRoomHeightControl } from '../services/global_levels.js?v=20260903c';

function renderFloorplanControls() {
  const controls = document.getElementById('floorplanStatusControls');
  const fp = S.project.floorplan;
  const clearButton = document.getElementById('btnClearFloorplan');
  if (clearButton) {
    clearButton.hidden = !fp;
    clearButton.disabled = !fp;
    clearButton.classList.toggle('hidden', !fp);
    clearButton.setAttribute('aria-hidden', fp ? 'false' : 'true');
  }
  if (!fp) {
    if (controls) controls.innerHTML = '';
    return false;
  }

  if (!controls) return false;
  const numericOpacity = Number(fp.opacity);
  const opacity = Number.isFinite(numericOpacity) ? numericOpacity : 0.5;
  const isSatellite = String(fp.kind || fp.backgroundType || '').trim().toLowerCase() === 'satellite';
  const typeLabel = isSatellite ? 'Satellit' : 'Grundriss';
  const opacityOptions = [0, 0.25, 0.5, 0.75, 1].map(value => (
    `<option value="${value}" ${Math.abs(opacity - value) < 0.01 ? 'selected' : ''}>${Math.round(value * 100)}%</option>`
  )).join('');
  controls.innerHTML = `
    <span class="floorplan-status-label">${escapeHtml(typeLabel)}</span>
    <select id="floorOpacity" aria-label="Deckkraft">
      ${opacityOptions}
    </select>
    ${isSatellite ? '' : `
      <label class="floorplan-status-lock">
        <input id="chkFloorplanLocked" type="checkbox" ${fp.locked ? 'checked' : ''}>
        Fixiert
      </label>
    `}
    ${isSatellite ? `<span class="floorplan-status-label">${Math.round((Number(fp.realWidthMm) || fp.width) / 10) / 100} × ${Math.round((Number(fp.realHeightMm) || fp.height) / 10) / 100} m</span>` : `
      <input id="floorMeasureMm" type="text" inputmode="numeric" placeholder="Referenzmass" value="${escapeHtml(S.floorplanMeasure?.referenceMm || fp.referenceMm || '')}" aria-label="Referenzmass in Millimeter">
      <button id="btnRemeasureFloorplan" class="btn" type="button">Neu vermessen</button>
    `}
  `;

  document.getElementById('floorOpacity')?.addEventListener('change', event => {
    fp.opacity = Number(event.target.value);
    AppRuntime.refresh(false);
  });
  document.getElementById('chkFloorplanLocked')?.addEventListener('change', event => {
    fp.locked = event.target.checked;
    AppRuntime.refresh(false);
  });
  document.getElementById('btnRemeasureFloorplan')?.addEventListener('click', () => {
    FloorplanController.startFloorplanRemeasure(document.getElementById('floorMeasureMm')?.value);
  });
  return true;
}

function syncProjectControls() {
  if (deferShellRender('project-controls', syncProjectControls)) return;
  // Global bei jedem App-Refresh synchronisieren; die Sichtbarkeit des roten
  // Löschbuttons darf nicht davon abhängen, welches Produktsystem seine
  // Sidebar gerade rendert.
  renderFloorplanControls();
  const gridSize = document.getElementById('selGridSize');
  if (gridSize) gridSize.value = String(S.project.gridSize);
  const helperGrid = document.getElementById('helperGridSize');
  if (helperGrid) helperGrid.value = String(Math.round(Number(S.project.helperGridSize) || 0));
  const snap = document.getElementById('chkSnap');
  if (snap) snap.checked = Boolean(S.project.snap);
  const grid = document.getElementById('chkGrid');
  if (grid) grid.checked = Boolean(S.project.showGrid);
  const chkHelperGrid = document.getElementById('chkHelperGrid');
  if (chkHelperGrid) chkHelperGrid.checked = Boolean(S.project.showHelperGrid);
  syncGlobalRoomHeightControl();
  const undoBtn = document.getElementById('btnUndo');
  if (undoBtn) undoBtn.disabled = !canUndo();
  const redoBtn = document.getElementById('btnRedo');
  if (redoBtn) redoBtn.disabled = !canRedo();
  const levelToggle = document.getElementById('btnToggleLevels');
  if (levelToggle) levelToggle.classList.toggle('primary', Boolean(S.ui.showLevelsPanel));
}

export {
  renderFloorplanControls,
  syncProjectControls
};
